
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/candidates/[candidate]",
      function () {
        return require("private-next-pages/elections/candidates/[candidate].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/candidates/[candidate]"])
      });
    }
  